import { createApp } from 'vue'
import App from './App.vue'
import store from './store'
import router from './router'
import JsonExcel from "vue-json-excel3";

createApp(App).use(store).use(router).component("downloadExcel", JsonExcel).mount('#app')
